// extracted by mini-css-extract-plugin
export default {"picture":"Picture_picture__B9LO3","mainImgMobile":"Picture_mainImgMobile__005u6"};